import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';
import { BillingEstimate, BillingEstimateParams } from '@recruitee/http-types';

@Injectable({ providedIn: 'root' })
export class BillingPlansHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public fetchBillingPlans() {
    return this.httpApi.get('/billing/plans');
  }

  public fetchActiveBillingPlan() {
    return this.httpApi.get('/billing/subscription/plan');
  }

  public fetchBillingEstimate(params: BillingEstimateParams): Observable<BillingEstimate> {
    return this.httpApi.post('/billing/estimate', null, params).pipe(map(data => data.estimate));
  }
}
